import type { CrmObject } from '@/types/crm';

import { HighlightCard } from '../highlights/HighlightCard';
import type { HighlightDefinition } from '../registry/entityTypeRegistry';

// 3 columns max on desktop matches the Attio-style overview layout — caps
// each card at a comfortable width and avoids the previous 4-col cramped feel.
const GRID_CLASS = 'grid grid-cols-2 md:grid-cols-3 gap-3';

interface Props {
  object: CrmObject;
  highlights: HighlightDefinition[];
}

export function HighlightsGrid({ object, highlights }: Props) {
  if (!highlights || highlights.length === 0) {
    return null;
  }

  const orgId = object.org_id;

  return (
    <div className={GRID_CLASS}>
      {highlights.map(def => (
        <HighlightCard
          key={`${def.kind}:${def.label}`}
          definition={def}
          object={object}
          orgId={orgId}
        />
      ))}
    </div>
  );
}
